export const lang = {
  national_id:"NIC",
  save_success: 'Patient registered!',
  patient_file:"Patient File",
  is_insured:"Assured"
};
